import { Sidebar } from 'flowbite-react';
import React from 'react';
import { Link, useLoaderData } from 'react-router-dom';
import CourseViewCard from './CourseViewCard';
import { AiFillHome, AiFillQuestionCircle } from "react-icons/ai";
import { ImBlog } from "react-icons/im";
import { HiServer } from "react-icons/hi";
import { MdTopic } from "react-icons/md";

const Courses = ({ sideNav }) => {
    const CoursesTopic = useLoaderData();
    return (
        <div className="container mx-auto px-3 md:px-5 mt-2 flex flex-col-reverse md:flex-row gap-4">
            <div className='grid md:grid-cols-1 lg:grid-cols-4 grid-cols-1 gap-4 w-full mb-5'>
                {CoursesTopic.map(course => <CourseViewCard adOnStyle={{ style: 'mb-0' }} key={course.course_id} course={course}></CourseViewCard>)}
            </div>
            <div className={sideNav ? 'block' : 'hidden'}>
                <div className="w-full border dark:border-gray-700 rounded-md h-fit">
                    <Sidebar aria-label="Sidebar with multi-level dropdown example">
                        <Sidebar.Items>
                            <Sidebar.ItemGroup>
                                <Link to='/home'>
                                    <Sidebar.Item
                                        icon={AiFillHome}>
                                        Home
                                    </Sidebar.Item>
                                </Link>
                                <Sidebar.Collapse
                                    icon={HiServer}
                                    label="Courses">
                                    {CoursesTopic.map(course => <Link to={`/course/${course.course_id}`}><Sidebar.Item icon={MdTopic} >{course.course_name.slice(0, 18) + '...'}</Sidebar.Item></Link>)}
                                </Sidebar.Collapse>
                                <Link to="/blog">
                                    <Sidebar.Item
                                        icon={ImBlog}>
                                        Blog
                                    </Sidebar.Item>
                                </Link>
                                <Link to="/faq">
                                    <Sidebar.Item
                                        icon={AiFillQuestionCircle}>
                                        FQA
                                    </Sidebar.Item>
                                </Link>
                            </Sidebar.ItemGroup>
                        </Sidebar.Items>
                    </Sidebar>
                </div>
            </div>
        </div>
    );
};

export default Courses;